function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import get from 'lodash/get';
import { isVNode, isFunction, isPlainObject } from '@cloud-sn/v-utils';
import { getNormalizeContent } from './utils';
import SubMixin from './mixins/sub';
export default {
  name: 'TableCell',
  mixins: [SubMixin],
  props: {
    rowPrefixCls: {
      type: String,
      default: ''
    },
    record: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    column: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    rowIdx: {
      type: Number,
      default: -1
    },
    colIdx: {
      type: Number,
      default: -1
    },
    indent: {
      type: Number,
      default: -1
    },
    expandIcon: {
      type: [Object, Boolean],
      default: false
    }
  },
  methods: {
    getCellProps: function getCellProps() {
      var column = this.column,
          record = this.record,
          colIdx = this.colIdx,
          rowIdx = this.rowIdx;
      var dataIndex = column.dataIndex,
          align = column.align,
          className = column.className,
          cellRender = column.cellRender,
          onCell = column.onCell; // const val = !dataIndex ? '' : get(record, dataIndex) || '';

      var val = '';

      if (dataIndex) {
        var v = get(record, dataIndex);
        val = v === undefined || v === null ? '' : v;
      }

      var cellProps = {
        content: val,
        className: className
      }; // align cell content

      if (align) {
        cellProps.style = {
          textAlign: align
        };
      }

      if (isFunction(onCell)) {
        cellProps = _objectSpread({}, cellProps, {}, onCell(record, rowIdx, column, colIdx));
      }

      if (isFunction(cellRender)) {
        // FIXME: 为什么要修改this指向？
        // http://opensource.cnsuning.com/uxcool/lerna-uxcool/issues/295
        var rv = cellRender.call({
          $createElement: this.$createElement,
          $refs: this.$refs
        }, val, record, rowIdx, column, colIdx); // Object

        if (rv && isPlainObject(rv) && !isVNode(rv)) {
          cellProps = _objectSpread({}, cellProps, {}, rv); // } else if (isVNode(rv) || typeof rv === 'string' || typeof rv === 'number') {
        } else if (rv !== undefined && rv !== null) {
          cellProps.content = rv;
        }
      }

      return cellProps;
    }
  },
  render: function render() {
    var h = arguments[0];
    var $createElement = this.$createElement,
        prefixCls = this.rowPrefixCls,
        fixed = this.fixed,
        getCellProps = this.getCellProps,
        column = this.column,
        indent = this.indent,
        indentSize = this.indentSize,
        expandIcon = this.expandIcon;

    var _getCellProps = getCellProps(),
        dangerouslySetInnerHTML = _getCellProps.dangerouslySetInnerHTML,
        _getCellProps$content = _getCellProps.content,
        content = _getCellProps$content === void 0 ? '' : _getCellProps$content,
        className = _getCellProps.className,
        _getCellProps$style = _getCellProps.style,
        style = _getCellProps$style === void 0 ? {} : _getCellProps$style,
        on = _getCellProps.on,
        cellProps = _objectWithoutProperties(_getCellProps, ["dangerouslySetInnerHTML", "content", "className", "style", "on"]);

    var _cellProps$colspan = cellProps.colspan,
        colspan = _cellProps$colspan === void 0 ? 1 : _cellProps$colspan,
        _cellProps$rowspan = cellProps.rowspan,
        rowspan = _cellProps$rowspan === void 0 ? 1 : _cellProps$rowspan; // 不渲染被设定为colspan和rowspan设定为0的单元格

    if (colspan === 0 || rowspan === 0) {
      return null;
    }

    var indentElement = expandIcon ? h("span", {
      "class": "".concat(prefixCls, "-indent indent-level-").concat(indent),
      "style": {
        paddingLeft: "".concat(indent * indentSize, "px")
      }
    }) : null; // 由于添加html内容需要一个额外标签, 可能会影响实际页面元素布局, 暂不提供html方式
    // const tdElement = dangerouslySetInnerHTML ? (
    //   <td class={className} style={style} {...{ attrs: cellProps, on }}>
    //     <span domProps={{ innerHTML: content }} />
    //   </td>
    //   ) : (
    //   <td class={className} style={style} {...{ attrs: cellProps, on }}>
    //     {content}
    //   </td>
    // );
    // 解决使用JSX或$createElement,生成 title时,由于table和fixed table共用VNode,导致不渲染的问题,
    // VNodes must be unique.(https://vuejs.org/v2/guide/render-function.html#Constraints)

    var normalizeContent = getNormalizeContent($createElement, column.$$_fixed, fixed, content);
    var tdElement = h("td", {
      "class": className,
      "style": style,
      "attrs": _objectSpread({}, cellProps),
      "on": _objectSpread({}, on)
    }, [indentElement, expandIcon, normalizeContent]);
    return tdElement;
  }
};